export class ReliabilityReportRemarkCreateModel {
  public ReliabilityReportId?: number;
  public IsVisibleToCustomer?: boolean;
  public Remark?: number;
}
